import { Badge, Box, Divider, Flex, Heading, Spinner, Text } from '@chakra-ui/react';

const InProgressPayoff = () => {
  return (
    <Box>
      <Flex mb={4}>
        <Box mr={4}>
          <Flex
            boxSize={8}
            rounded="full"
            p={1}
            bgColor="blue.50"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner speed="1s" color="blue.500" size="sm" />
          </Flex>
        </Box>
        <Box>
          <Badge variant="outline" colorScheme="blue" my={2}>
            IN PROGRESS
          </Badge>
          <Text color="gray.600">RETRIEVING YOUR PAYOFF</Text>
          <Heading as="h3" fontSize="xx-large" fontWeight="bold">
            We're on it
          </Heading>
        </Box>
      </Flex>
      <Divider my={4} />
      <Text fontSize="sm" color="gray.600">
        Our system is actively retrieving your official payoff from your lender. This typically
        completes within a few minutes.
      </Text>
    </Box>
  );
};

export default InProgressPayoff;
